import axiosInstance from './axios';

export const taskService = {
  getTasks: () => axiosInstance.get(`/api/tasks`),
  createTask: (data) => axiosInstance.post(`/api/tasks`, data),
  updateTask: (id, data) => axiosInstance.put(`/api/tasks/${id}`, data),
  deleteTask: (id) => axiosInstance.delete(`/api/tasks/${id}`)
};
